var map = {
	"./Arcobaleno/arcobaleno1.jpg": 448,
	"./Arcobaleno/arcobaleno2.jpg": 4783,
	"./Arcobaleno/arcobaleno3.jpg": 2114,
	"./Mamma/0002_5.jpg": 5322,
	"./Mamma/F1000013.jpg": 9827,
	"./Mamma/F1000018.jpg": 1564,
	"./Photos-accueil/Erminio.jpg": 8912,
	"./Photos-accueil/Iolanda_4.jpg": 6654,
	"./Photos-accueil/Paysage.jpg": 8753
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2729;